// extracted by mini-css-extract-plugin
export default {"auth__page":"auth__page--VhdnG","auth__dialog":"auth__dialog--26gvf","auth__image":"auth__image--wgmMr","auth__logo":"auth__logo--34YlR","auth__title":"auth__title--XJ-CS","auth__content":"auth__content--1v5md","auth__close":"auth__close--xGrwO","auth__button":"auth__button--U6DyH"};
    if(module.hot) {
      // 1747648130381
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  